import { render, staticRenderFns } from "./_sidemenu.vue?vue&type=template&id=6e6a4880&"
import script from "./_sidemenu.vue?vue&type=script&lang=js&"
export * from "./_sidemenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports